import { withInstall } from '@hd-front-end/utils'
import Row from './src/row.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElRow: SFCWithInstall<typeof Row> = withInstall(Row)
export default ElRow

export * from './src/row'
export * from './src/constants'
